import React from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Input, Modal, Select } from 'antd';
import ContentTypesDropdown from '../ContentTypesDropdown';
import { useCreatePermissionMutation, useUpdatePermissionMutation } from '../../redux/Api/UserManagment/uMPermissionsApiSlice';
import { toast } from 'react-toastify';
import Loader from '../../pages/pages/loader';

const EditCreatePermissions = ({ state, open, setOpen, permission }) => {
    const [createPermission, { isLoading: isCreating }] = useCreatePermissionMutation()
    const [updatePermission, { isLoading: isUpdating }] = useUpdatePermissionMutation()

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: permission ? permission.name : "",
            codename: permission ? permission.codename : "",
            content_type: permission ? permission.content_type : null,
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Name is required'),
            codename: Yup.string().required('Code is required'),
            content_type: Yup.string().required('Content Type is required'),
        }),
        onSubmit: async (values) => {
            try {
                if (state === "edit") {
                    await updatePermission({ id: permission?.id, data: values }).unwrap()
                    toast.success('Permission updated successfully')
                }
                if (state === "create") {
                    await createPermission(values).unwrap()
                    toast.success('Permission created successfully')
                }
                setOpen(false)
            } catch (error) {
                if (error?.data) {
                    const errorMessages = Object.values(error.data).flat()
                    errorMessages.forEach(message => {
                        toast.error(message)
                    })
                } else {
                    toast.error('Failed to save permission')
                }
            }
        },
    })

    return (
        <Modal
            className='customModal'
            open={open}
            title={state === "edit" ? "Edit Permission" : "Add New Permission"}
            onCancel={() => setOpen(false)}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={isCreating || isUpdating} onClick={() => {
                    if (Object.keys(validation.errors).length !== 0) {
                        Object.keys(validation.errors).map((key) => {
                            toast.error(validation.errors[key]);
                        });
                        return;
                    }
                    validation.handleSubmit();
                }}>
                    Submit
                </Button>
            ]}
        >
            <Loader isLoading={isCreating || isUpdating} />
            <div className=" mb-3">
                <label className="" >Name</label>
                <Input
                    required
                    type="name"
                    name='name'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name}
                />
                {validation.touched.name &&
                    validation.errors.name ? (
                    <p className='text-danger'>
                        {validation.errors.name}
                    </p>
                ) : null}
            </div>
            <div className=" mb-3">
                <label className="" >Permission Code</label>
                <Input
                    required
                    type="text"
                    name='codename'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.codename}
                />
                {validation.touched.codename &&
                    validation.errors.codename ? (
                    <p className='text-danger'>
                        {validation.errors.codename}
                    </p>
                ) : null}
            </div>
            <div>
                <ContentTypesDropdown
                    onBlur={validation.handleBlur}
                    onChange={validation.setFieldValue}
                    value={validation.values.content_type}
                    multi={false}
                />
                {validation.touched.content_type && validation.errors.content_type ? (
                    <p className='text-danger'>{validation.errors.content_type}</p>
                ) : null}
            </div>
        </Modal>
    )
}

export default EditCreatePermissions